export default "__VITE_ASSET__5suu7wPD__"